// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Ledger — operational data table ── */
.ledger {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--fs-2xs);
}

.ledger thead th {
  position: sticky;
  top: calc(var(--lb-topbar-h, 52px) + var(--table-toolbar-h, 57px));
  z-index: 10;
  background: var(--bg);
  font-family: var(--mono);
  font-size: var(--fs-micro);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-muted);
  text-align: left;
  padding: 10px 12px 10px 0;
  border-bottom: 1px solid var(--border);
}
.ledger thead th:first-child {
  padding-left: 24px;
}
.ledger thead th:last-child {
  padding-right: 24px;
  text-align: left;
}
.ledger thead th.num {
  text-align: left;
}

.ledger tbody tr {
  position: relative;
  border-bottom: 1px solid var(--border-soft);
  cursor: pointer;
  transition: background 100ms ease;
}

.ledger tbody td {
  padding: 12px 12px 12px 0;
  vertical-align: middle;
  color: var(--text);
  /* Let long single words break as a last resort so the auto-layout table can
     shrink to its container instead of overflowing the page. Without this the
     table's min-content width can exceed a narrow content column (e.g. split
     screen / devtools open), pushing past the viewport and surfacing a
     page-level horizontal scrollbar + cells bleeding onto the dark body. */
  overflow-wrap: anywhere;
}
.ledger.ledger--compact tbody td {
  padding-top: 6px;
  padding-bottom: 6px;
}
.ledger.ledger--compact tbody tr {
  font-size: var(--fs-2xs);
}
.ledger.ledger--comfortable tbody td {
  padding-top: 14px;
  padding-bottom: 14px;
}
.ledger tbody td:first-child {
  padding-left: 24px;
  position: relative;
}
.ledger tbody td:last-child {
  padding-right: 24px;
  text-align: left;
}
.ledger tbody td.num {
  text-align: left;
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
}

/* ── Status row tints ── */
.ledger tbody tr.s-err {
  background: rgba(180, 35, 24, 0.045);
}
.ledger tbody tr.s-warn {
  background: rgba(180, 83, 9, 0.04);
}
.ledger tbody tr.s-err:hover {
  background: rgba(180, 35, 24, 0.075);
}
.ledger tbody tr.s-warn:hover {
  background: rgba(180, 83, 9, 0.07);
}
.ledger tbody tr.s-info:hover,
.ledger tbody tr.s-ok:hover,
.ledger tbody tr:hover {
  background: var(--bg-alt);
}

/* ── Keyboard cursor (J/K vim navigation) — distinct from the opened (active)
   row: a quieter paper-elev wash + a deep-navy left bar. ── */
.ledger tbody tr.is-cursor:not(.is-active) {
  background: var(--bg-alt);
}
.ledger tbody tr.is-cursor:not(.is-active) td:first-child {
  box-shadow: inset 3px 0 0 var(--signal-deep);
}

/* ── Active row — the row whose detail drawer is open. Blue wash + a 3px
   inset accent on the first cell, mirroring the active sidebar nav item. ── */
.ledger tbody tr.is-active,
.ledger tbody tr.is-active:hover {
  background: var(--signal-soft);
}
.ledger tbody tr.is-active td:first-child::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--signal);
}
[data-theme='dark'] .ledger tbody tr.is-active,
[data-theme='dark'] .ledger tbody tr.is-active:hover {
  background: rgba(12, 107, 240, 0.18);
}

/* ── s-new — cyan pip before first cell ── */
.ledger tbody tr.s-new td:first-child {
  padding-left: 26px;
}
.ledger tbody tr.s-new td:first-child::before {
  content: '';
  position: absolute;
  left: 12px;
  top: 50%;
  margin-top: -3px;
  width: 6px;
  height: 6px;
  background: var(--cyan);
  border-radius: 999px;
}

/* ── Dark mode overrides ── */
[data-theme='dark'] .ledger thead th {
  color: var(--text-muted);
  border-color: var(--border);
}
[data-theme='dark'] .ledger tbody tr {
  border-color: var(--border-soft);
}
[data-theme='dark'] .ledger tbody tr.s-err {
  background: rgba(180, 35, 24, 0.11);
}
[data-theme='dark'] .ledger tbody tr.s-warn {
  background: rgba(180, 83, 9, 0.09);
}
[data-theme='dark'] .ledger tbody tr.s-err:hover {
  background: rgba(180, 35, 24, 0.16);
}
[data-theme='dark'] .ledger tbody tr.s-warn:hover {
  background: rgba(180, 83, 9, 0.14);
}
[data-theme='dark'] .ledger tbody td {
  color: var(--text);
}

/* ── Cell sub-elements ── */
.ledger-rol {
  font-family: var(--mono);
  font-size: var(--fs-meta);
  color: var(--text);
}

.ledger-titulo {
  color: var(--text);
  font-weight: 500;
}
.ledger-partes {
  display: block;
  color: var(--text-muted);
  font-size: var(--fs-xs);
  font-weight: 400;
  margin-top: 1px;
}

.ledger-tribunal {
  color: var(--text-secondary);
  font-size: var(--fs-meta);
}
.ledger-tribunal small {
  display: block;
  color: var(--text-muted);
  font-size: var(--fs-sm);
  margin-top: 1px;
}

/* ── Status dot pill ── */
.status-dot-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: var(--fs-xs);
  color: var(--text-secondary);
  /* Status labels are atomic — never break them mid-word (overrides the cell's
     overflow-wrap:anywhere). They wrap only at spaces ("Procesando pago"). */
  overflow-wrap: normal;
}
.status-dot-pill .dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  flex-shrink: 0;
}
.status-dot-pill.s-ok .dot {
  background: var(--ok);
}
.status-dot-pill.s-warn .dot {
  background: var(--warn);
}
.status-dot-pill.s-err .dot {
  background: var(--danger);
}
.status-dot-pill.s-info .dot {
  background: var(--info);
}
.status-dot-pill.s-new .dot {
  background: var(--cyan);
}
/* "Sin diligencia" — gris sin relleno: la causa no tiene diligencia, así que el
   punto es un anillo vacío, no un estado lleno. */
.status-dot-pill.s-idle .dot {
  background: transparent;
  border: 1.5px solid var(--text-muted);
}
/* "Borrador" — gris relleno: un encargo capturado pero aún no enviado se lee
   como un gris sólido y quieto, distinto del "Sin diligencia" hueco. */
.status-dot-pill.s-draft .dot {
  background: var(--text-muted);
}
/* "En curso" — cian: estado vivo (pagada, esperando la actuación del receptor),
   distinto del azul "Cotizando". */
.status-dot-pill.s-live .dot {
  background: var(--cyan);
}
/* "Procesando pago" — ámbar con un punto pulsante: pago en vuelo ("de
   interés"), entre la oferta aceptada y la confirmación. */
.status-dot-pill.s-pay .dot {
  background: var(--warn);
  animation: ledger-pay-pulse 1.4s ease-in-out infinite;
}
@keyframes ledger-pay-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(1.45);
  }
}
@media (prefers-reduced-motion: reduce) {
  .status-dot-pill.s-pay .dot {
    animation: none;
  }
}

/* ── IA chip ── */
.ia-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px 2px 6px;
  background: var(--cream-soft);
  border: 1px solid var(--border);
  border-radius: var(--radius-1);
  font-size: var(--fs-xs);
  color: var(--cream-deep);
}
.ia-chip::before {
  content: 'IA';
  font-family: var(--mono);
  font-size: var(--fs-pico);
  background: var(--cream-deep);
  color: var(--cream-soft);
  padding: 1px 4px;
  border-radius: 2px;
  letter-spacing: 0.1em;
}

/* ── Plazo (deadline) ── */
.plazo {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.plazo .dias {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
}
.plazo .lbl {
  color: var(--text-muted);
  font-size: var(--fs-sm);
}
.plazo.tight .dias {
  color: var(--danger);
}
.plazo.medium .dias {
  color: var(--warn);
}
.plazo.loose .dias {
  color: var(--text-secondary);
}

/* ── Recibido timestamp ── */
.ledger-recibido {
  color: var(--text-muted);
  font-size: var(--fs-xs);
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
}

/* ── Monto (CLP, mono tabular) — celda de importe canónica. Reemplaza al
   one-off .pg-money de Pagos. ── */
.ledger-money {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-note);
  color: var(--text);
}

/* ── Fecha (mono tabular) — celda de fecha canónica. Reemplaza al one-off
   .pg-date de Pagos. (Para plazos con contador, usar el componente Plazo.) ── */
.ledger-date {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-2xs);
  color: var(--text);
}

/* ── Tiempo relativo (RelTime) — columna "Actualizado": instante de última
   actualización en lenguaje relativo ("hace 20 min", "ayer", "hace 5 d").
   Secundaria y atenuada — recencia para seguir, no dato primario. ── */
.ledger-reltime {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-xs);
  color: var(--text-muted);
  white-space: nowrap;
}

/* ── Subtexto de celda — una línea atenuada bajo el contenido principal de una
   celda (estado, fecha o monto). \`tone\` la tiñe: warn (atención) o err
   (problema). Canónico; reemplaza a los one-offs .pg-sub y .est-sub. ── */
.ledger-cell-sub {
  display: block;
  margin-top: 4px;
  max-width: 36ch;
  font-size: var(--fs-sm);
  line-height: 1.35;
  color: var(--text-muted);
}
.ledger-cell-sub.is-warn {
  color: var(--warn);
}
.ledger-cell-sub.is-err {
  color: var(--danger);
}

/* ── Row actions ── */
.ledger-acciones {
  display: inline-flex;
  gap: 6px;
}
.ledger-acciones button {
  height: 24px;
  padding: 0 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius-1);
  background: var(--bg);
  font-size: var(--fs-sm);
  font-family: var(--sans);
  color: var(--text-secondary);
  cursor: pointer;
  transition:
    background 100ms ease,
    border-color 100ms ease;
}
.ledger-acciones button:hover {
  background: var(--bg-alt);
  border-color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/shared/Ledger/Ledger.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kEAAkE;EAClE,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB;;;;2EAIyE;EACzE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;8DAC8D;AAC9D;EACE,yBAAyB;AAC3B;AACA;EACE,4CAA4C;AAC9C;;AAEA;8EAC8E;AAC9E;;EAEE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;AACA;;EAEE,oCAAoC;AACtC;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,4BAA4B;EAC5B;6EAC2E;EAC3E,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;kDACkD;AAClD;EACE,uBAAuB;EACvB,qCAAqC;AACvC;AACA;uEACuE;AACvE;EACE,6BAA6B;AAC/B;AACA;mCACmC;AACnC;EACE,uBAAuB;AACzB;AACA;2DAC2D;AAC3D;EACE,uBAAuB;EACvB,qDAAqD;AACvD;AACA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;mCACmC;AACnC;EACE,wBAAwB;EACxB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;gFACgF;AAChF;EACE,wBAAwB;EACxB,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;uEAEuE;AACvE;EACE,wBAAwB;EACxB,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;0EAE0E;AAC1E;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;EACf;;2BAEyB;AAC3B;AACA;EACE,yBAAyB;EACzB,+BAA+B;AACjC","sourcesContent":["/* ── Ledger — operational data table ── */\n.ledger {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--fs-2xs);\n}\n\n.ledger thead th {\n  position: sticky;\n  top: calc(var(--lb-topbar-h, 52px) + var(--table-toolbar-h, 57px));\n  z-index: 10;\n  background: var(--bg);\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n  text-align: left;\n  padding: 10px 12px 10px 0;\n  border-bottom: 1px solid var(--border);\n}\n.ledger thead th:first-child {\n  padding-left: 24px;\n}\n.ledger thead th:last-child {\n  padding-right: 24px;\n  text-align: left;\n}\n.ledger thead th.num {\n  text-align: left;\n}\n\n.ledger tbody tr {\n  position: relative;\n  border-bottom: 1px solid var(--border-soft);\n  cursor: pointer;\n  transition: background 100ms ease;\n}\n\n.ledger tbody td {\n  padding: 12px 12px 12px 0;\n  vertical-align: middle;\n  color: var(--text);\n  /* Let long single words break as a last resort so the auto-layout table can\n     shrink to its container instead of overflowing the page. Without this the\n     table's min-content width can exceed a narrow content column (e.g. split\n     screen / devtools open), pushing past the viewport and surfacing a\n     page-level horizontal scrollbar + cells bleeding onto the dark body. */\n  overflow-wrap: anywhere;\n}\n.ledger.ledger--compact tbody td {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n.ledger.ledger--compact tbody tr {\n  font-size: var(--fs-2xs);\n}\n.ledger.ledger--comfortable tbody td {\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n.ledger tbody td:first-child {\n  padding-left: 24px;\n  position: relative;\n}\n.ledger tbody td:last-child {\n  padding-right: 24px;\n  text-align: left;\n}\n.ledger tbody td.num {\n  text-align: left;\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── Status row tints ── */\n.ledger tbody tr.s-err {\n  background: rgba(180, 35, 24, 0.045);\n}\n.ledger tbody tr.s-warn {\n  background: rgba(180, 83, 9, 0.04);\n}\n.ledger tbody tr.s-err:hover {\n  background: rgba(180, 35, 24, 0.075);\n}\n.ledger tbody tr.s-warn:hover {\n  background: rgba(180, 83, 9, 0.07);\n}\n.ledger tbody tr.s-info:hover,\n.ledger tbody tr.s-ok:hover,\n.ledger tbody tr:hover {\n  background: var(--bg-alt);\n}\n\n/* ── Keyboard cursor (J/K vim navigation) — distinct from the opened (active)\n   row: a quieter paper-elev wash + a deep-navy left bar. ── */\n.ledger tbody tr.is-cursor:not(.is-active) {\n  background: var(--bg-alt);\n}\n.ledger tbody tr.is-cursor:not(.is-active) td:first-child {\n  box-shadow: inset 3px 0 0 var(--signal-deep);\n}\n\n/* ── Active row — the row whose detail drawer is open. Blue wash + a 3px\n   inset accent on the first cell, mirroring the active sidebar nav item. ── */\n.ledger tbody tr.is-active,\n.ledger tbody tr.is-active:hover {\n  background: var(--signal-soft);\n}\n.ledger tbody tr.is-active td:first-child::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: var(--signal);\n}\n[data-theme='dark'] .ledger tbody tr.is-active,\n[data-theme='dark'] .ledger tbody tr.is-active:hover {\n  background: rgba(12, 107, 240, 0.18);\n}\n\n/* ── s-new — cyan pip before first cell ── */\n.ledger tbody tr.s-new td:first-child {\n  padding-left: 26px;\n}\n.ledger tbody tr.s-new td:first-child::before {\n  content: '';\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  margin-top: -3px;\n  width: 6px;\n  height: 6px;\n  background: var(--cyan);\n  border-radius: 999px;\n}\n\n/* ── Dark mode overrides ── */\n[data-theme='dark'] .ledger thead th {\n  color: var(--text-muted);\n  border-color: var(--border);\n}\n[data-theme='dark'] .ledger tbody tr {\n  border-color: var(--border-soft);\n}\n[data-theme='dark'] .ledger tbody tr.s-err {\n  background: rgba(180, 35, 24, 0.11);\n}\n[data-theme='dark'] .ledger tbody tr.s-warn {\n  background: rgba(180, 83, 9, 0.09);\n}\n[data-theme='dark'] .ledger tbody tr.s-err:hover {\n  background: rgba(180, 35, 24, 0.16);\n}\n[data-theme='dark'] .ledger tbody tr.s-warn:hover {\n  background: rgba(180, 83, 9, 0.14);\n}\n[data-theme='dark'] .ledger tbody td {\n  color: var(--text);\n}\n\n/* ── Cell sub-elements ── */\n.ledger-rol {\n  font-family: var(--mono);\n  font-size: var(--fs-meta);\n  color: var(--text);\n}\n\n.ledger-titulo {\n  color: var(--text);\n  font-weight: 500;\n}\n.ledger-partes {\n  display: block;\n  color: var(--text-muted);\n  font-size: var(--fs-xs);\n  font-weight: 400;\n  margin-top: 1px;\n}\n\n.ledger-tribunal {\n  color: var(--text-secondary);\n  font-size: var(--fs-meta);\n}\n.ledger-tribunal small {\n  display: block;\n  color: var(--text-muted);\n  font-size: var(--fs-sm);\n  margin-top: 1px;\n}\n\n/* ── Status dot pill ── */\n.status-dot-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: var(--fs-xs);\n  color: var(--text-secondary);\n  /* Status labels are atomic — never break them mid-word (overrides the cell's\n     overflow-wrap:anywhere). They wrap only at spaces (\"Procesando pago\"). */\n  overflow-wrap: normal;\n}\n.status-dot-pill .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n.status-dot-pill.s-ok .dot {\n  background: var(--ok);\n}\n.status-dot-pill.s-warn .dot {\n  background: var(--warn);\n}\n.status-dot-pill.s-err .dot {\n  background: var(--danger);\n}\n.status-dot-pill.s-info .dot {\n  background: var(--info);\n}\n.status-dot-pill.s-new .dot {\n  background: var(--cyan);\n}\n/* \"Sin diligencia\" — gris sin relleno: la causa no tiene diligencia, así que el\n   punto es un anillo vacío, no un estado lleno. */\n.status-dot-pill.s-idle .dot {\n  background: transparent;\n  border: 1.5px solid var(--text-muted);\n}\n/* \"Borrador\" — gris relleno: un encargo capturado pero aún no enviado se lee\n   como un gris sólido y quieto, distinto del \"Sin diligencia\" hueco. */\n.status-dot-pill.s-draft .dot {\n  background: var(--text-muted);\n}\n/* \"En curso\" — cian: estado vivo (pagada, esperando la actuación del receptor),\n   distinto del azul \"Cotizando\". */\n.status-dot-pill.s-live .dot {\n  background: var(--cyan);\n}\n/* \"Procesando pago\" — ámbar con un punto pulsante: pago en vuelo (\"de\n   interés\"), entre la oferta aceptada y la confirmación. */\n.status-dot-pill.s-pay .dot {\n  background: var(--warn);\n  animation: ledger-pay-pulse 1.4s ease-in-out infinite;\n}\n@keyframes ledger-pay-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.4;\n    transform: scale(1.45);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .status-dot-pill.s-pay .dot {\n    animation: none;\n  }\n}\n\n/* ── IA chip ── */\n.ia-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 8px 2px 6px;\n  background: var(--cream-soft);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1);\n  font-size: var(--fs-xs);\n  color: var(--cream-deep);\n}\n.ia-chip::before {\n  content: 'IA';\n  font-family: var(--mono);\n  font-size: var(--fs-pico);\n  background: var(--cream-deep);\n  color: var(--cream-soft);\n  padding: 1px 4px;\n  border-radius: 2px;\n  letter-spacing: 0.1em;\n}\n\n/* ── Plazo (deadline) ── */\n.plazo {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.plazo .dias {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n}\n.plazo .lbl {\n  color: var(--text-muted);\n  font-size: var(--fs-sm);\n}\n.plazo.tight .dias {\n  color: var(--danger);\n}\n.plazo.medium .dias {\n  color: var(--warn);\n}\n.plazo.loose .dias {\n  color: var(--text-secondary);\n}\n\n/* ── Recibido timestamp ── */\n.ledger-recibido {\n  color: var(--text-muted);\n  font-size: var(--fs-xs);\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── Monto (CLP, mono tabular) — celda de importe canónica. Reemplaza al\n   one-off .pg-money de Pagos. ── */\n.ledger-money {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-note);\n  color: var(--text);\n}\n\n/* ── Fecha (mono tabular) — celda de fecha canónica. Reemplaza al one-off\n   .pg-date de Pagos. (Para plazos con contador, usar el componente Plazo.) ── */\n.ledger-date {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-2xs);\n  color: var(--text);\n}\n\n/* ── Tiempo relativo (RelTime) — columna \"Actualizado\": instante de última\n   actualización en lenguaje relativo (\"hace 20 min\", \"ayer\", \"hace 5 d\").\n   Secundaria y atenuada — recencia para seguir, no dato primario. ── */\n.ledger-reltime {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n/* ── Subtexto de celda — una línea atenuada bajo el contenido principal de una\n   celda (estado, fecha o monto). `tone` la tiñe: warn (atención) o err\n   (problema). Canónico; reemplaza a los one-offs .pg-sub y .est-sub. ── */\n.ledger-cell-sub {\n  display: block;\n  margin-top: 4px;\n  max-width: 36ch;\n  font-size: var(--fs-sm);\n  line-height: 1.35;\n  color: var(--text-muted);\n}\n.ledger-cell-sub.is-warn {\n  color: var(--warn);\n}\n.ledger-cell-sub.is-err {\n  color: var(--danger);\n}\n\n/* ── Row actions ── */\n.ledger-acciones {\n  display: inline-flex;\n  gap: 6px;\n}\n.ledger-acciones button {\n  height: 24px;\n  padding: 0 8px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1);\n  background: var(--bg);\n  font-size: var(--fs-sm);\n  font-family: var(--sans);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition:\n    background 100ms ease,\n    border-color 100ms ease;\n}\n.ledger-acciones button:hover {\n  background: var(--bg-alt);\n  border-color: var(--text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
